import React from "react";
import MuiGrid, {
  Grid2Props as MuiGridProps,
} from "@mui/material/Unstable_Grid2";

import { multiplySpacing, ResponsiveValue } from "../../theme/grid";
import { withDisplayName } from "../../utils/displayName";

export interface GridProps extends Omit<MuiGridProps, "spacing"> {
  /**
   * Defines the space between grid items.
   * Each unit represents 4px (GRID_SIZE).
   *
   * Can be a single number or an object with responsive breakpoints.
   *
   * @default 0
   *
   * @example
   * // Single value
   * spacing={2} // 8px (2 * 4px)
   *
   * @example
   * // Responsive values
   * spacing={{ xs: 1, sm: 2, md: 4 }} // 4px, 8px, 16px
   */
  spacing?: ResponsiveValue<number>;
  /**
   * Defines the space between grid rows.
   * Each unit represents 4px (GRID_SIZE).
   *
   * Can be a single number or an object with responsive breakpoints, see spacing prop for more details.
   *
   * @default 0
   */
  rowSpacing?: ResponsiveValue<number>;
  /**
   * Defines the space between grid columns.
   * Each unit represents 4px (GRID_SIZE).
   *
   * Can be a single number or an object with responsive breakpoints, see spacing prop for more details.
   *
   * @default 0
   */
  columnSpacing?: ResponsiveValue<number>;
}

export const OsGrid = React.forwardRef<HTMLDivElement, GridProps>(
  (props, ref) => {
    const { spacing, rowSpacing, columnSpacing, ...rest } = props;
    return (
      <MuiGrid
        ref={ref}
        spacing={multiplySpacing(spacing)}
        rowSpacing={multiplySpacing(rowSpacing)}
        columnSpacing={multiplySpacing(columnSpacing)}
        {...rest}
      />
    );
  },
);
withDisplayName(OsGrid, "OsGrid");
